import script from "./InsightGrid.vue?vue&type=script&setup=true&lang=js"
export * from "./InsightGrid.vue?vue&type=script&setup=true&lang=js"

import "./InsightGrid.vue?vue&type=style&index=0&id=2fcbeae8&scoped=true&lang=css"

import exportComponent from "../../../node_modules/.pnpm/vue-loader@17.4.2_@vue+comp_97cadfdcf4133f8fa1b05a91fee9f26b/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2fcbeae8"]])

export default __exports__